import { z } from "zod";

export const SessionPreferences = z.object({
  hideRibbonCarousel_20230825: z.boolean().nullish(),
  theme: z.string().nullish(),
});

export type SessionPreferences = z.infer<typeof SessionPreferences>;
